import getFocusableElements from 'hb-react/shared/utils/getFocusableElements';

const getNextFocusableElements = (context, direction) => {
  if (context) {
    const focusableItems = getFocusableElements(context);
    const activeIndex = focusableItems.indexOf(document.activeElement);
    const defaultIndex = direction > 0 ? 0 : focusableItems.length - 1;
    const nextIndex = activeIndex + direction;
    const isNoNextIndex =
      activeIndex === -1 ||
      (direction > 0 ? nextIndex > focusableItems.length - 1 : nextIndex < 0);
    const nextElementIndex = isNoNextIndex ? defaultIndex : nextIndex;

    return focusableItems[nextElementIndex] || focusableItems[defaultIndex];
  }
};

export default getNextFocusableElements;
